import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Label } from '@/components/ui/label'
import { Pencil, X } from 'lucide-react'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { PaymentRow } from '../sub-components/PaymentRow'
import { PaymentRowInfo } from '../sub-components/PaymentRowInfo'

interface EditPaymentDescriptionModalProps {
  isOpen: boolean
  onClose: () => void
  description: string | null
  onSave: (description: string | null) => void
  isPending: boolean
  payment: PaymentRow
}

export const EditPaymentDescriptionModal = ({
  isOpen,
  onClose,
  description,
  onSave,
  isPending,
  payment,
}: EditPaymentDescriptionModalProps) => {
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      description: description ?? '',
    },
  })

  useEffect(() => {
    reset({ description: description ?? '' })
  }, [description, reset])

  const onSubmit = (data: { description: string }) => {
    onSave(data.description.trim() || null)
  }

  if (!isOpen) return null

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Editar Descripción de un pago</DialogTitle>
          <DialogDescription>
            Modifica la descripción del período de pago.
          </DialogDescription>
        </DialogHeader>

        <PaymentRowInfo payment={payment} />

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 my-4">
          <div className="space-y-2">
            <Label htmlFor="description">Descripción</Label>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <textarea
                  id="description"
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-background min-h-[100px] resize-none"
                  value={field.value}
                  onChange={e => field.onChange(e.target.value)}
                  disabled={isPending}
                  placeholder="Ej: Cuota 1/6"
                />
              )}
            />
          </div>
        </form>

        <DialogFooter className="mt-4">
          <div className="flex justify-between w-full">
            <Button variant="outline" type="button" onClick={onClose} disabled={isPending}>
              <X className="h-3.5 w-3.5 mr-1.5" />
              Cancelar
            </Button>
            <Button
              variant="info"
              onClick={handleSubmit(onSubmit)}
              disabled={isPending}
            >
              <Pencil className="h-3.5 w-3.5 mr-1.5" />
              Guardar
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
